import React from "react";
import { Chart } from "react-google-charts";
import { isMobile } from "../../helperFunc";

// Normalizes commodity names for consistent key usage
const normalizeName = (name) => name.trim().toLowerCase().replace(/\s+/g, "");

// Generates chart configuration including data and slice colors
const generateChartConfig = (commodityData) => {
  const totalQuantity = commodityData?.reduce(
    (sum, commodity) => sum + commodity.quantity,
    0
  );

  if (totalQuantity === 0) return { data: [], slices: {} };

  const data = [
    [
      "Commodity",
      "Quantity",
      { role: "tooltip", type: "string", p: { html: true } },
    ],
  ];
  const slices = {};

  commodityData?.forEach((commodity, index) => {
    const percentage = ((commodity?.quantity / totalQuantity) * 100).toFixed(1);
    const label = commodity?.commodityName;
    const color = commodity?.commodityColor;
    const tooltip = `<div style="padding: 5px; font-size: 16px; font-weight: 500; color: #5a5a5a; line-height: 21px;">
    <div style="font-size: 18px; font-weight: 500; color: #333;">
      ${commodity.commodityName}
    </div>
    <div>${percentage}%</div>
  </div>`;

    data.push([label, commodity.quantity, tooltip]);
    slices[index] = { color };
  });

  return { data, slices };
};

const CommodityPieChart = ({ commodityData }) => {
  if (!commodityData || commodityData?.length === 0) {
    return null;
  }

  // Generate the chart configuration (data and slices) based on the provided commodity data and colors
  const { data, slices } = generateChartConfig(commodityData);

  if (data.length <= 1) return null; // Return nothing if no valid data is present for the chart

  const options = {
    legend: "none",
    slices,
    chartArea: { width: "85%", height: "85%" },
    pieSliceText: "label",
    tooltip: { isHtml: true, trigger: "focus" }, // Use focus instead of hover
    pieSliceTextStyle: {
      color: "white",
      fontSize: 14,
      bold: true,
    },
    pieHole: 0,
  };

  // Handles chart clicks and logs the commodity name
  const handleChartClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const dataTable = chartWrapper.getDataTable();
    const selection = chart.getSelection();

    if (selection.length > 0) {
      const row = selection[0].row;
      const label = dataTable.getValue(row, 0);
      const commodityName = label;
    }
  };

  // Add this style to prevent pointer events on the tooltip
  const tooltipStyle = `
    .google-visualization-tooltip {
      pointer-events: none; /* Prevents interaction with the tooltip itself */
    }
  `;

  return (
    <>
      <style>{tooltipStyle}</style>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: isMobile ? "236px" : "400px",
          width: isMobile ? "236px" : "370px",
        }}
      >
        <Chart
          chartType="PieChart"
          data={data}
          options={options}
          height="100%"
          width={isMobile && "100%"}
          chartEvents={[
            {
              eventName: "select",
              callback: handleChartClick,
            },
          ]}
        />
      </div>
    </>
  );
};

export default CommodityPieChart;
